import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo, useId } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useOnDragEnd } from './hooks/use-on-drag-end';
import * as Styled from './styles';
import * as SX from './sx';
import type { SortableListProps as Props } from './types';

export const SortableList = memo(
  ({ className, items, renderItem, onChange }: Props) => {
    const id = useId();
    const onDragEnd = useOnDragEnd(items, onChange);
    return (
      <Styled.Wrapper onDragEnd={onDragEnd}>
        <Droppable droppableId={id}>
          {(drop) => (
            <Styled.List
              className={classnames('SortableList', className)}
              ref={drop.innerRef}
              {...drop.droppableProps}
              flexDirection="column"
            >
              {items.map((x, index) => (
                <Draggable
                  isDragDisabled={x.disable}
                  draggableId={x.id}
                  index={index}
                  key={x.id}
                >
                  {(drag, { isDragging }) => (
                    <Styled.Item
                      direction="row-reverse"
                      alignItems="center"
                      {...drag.draggableProps}
                      {...drag.dragHandleProps}
                      ref={drag.innerRef}
                    >
                      <Box sx={SX.item(isDragging)}>
                        {renderItem ? renderItem(x) : x.label}
                      </Box>

                      {/* <Box {...drag.dragHandleProps} display="flex">
                          <Styled.Handler name="reorder" size={18} />
                        </Box> */}
                    </Styled.Item>
                  )}
                </Draggable>
              ))}
              {drop.placeholder}
            </Styled.List>
          )}
        </Droppable>
      </Styled.Wrapper>
    );
  }
);

SortableList.displayName = 'SortableList';
